package de.oevbs.kunde.kundenportal2.services.contact

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.PortalContactNotes
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.contact.ContactMessage
import de.oevbs.kunde.kundenportal2.model.services.contact.ContactMessageInit
import de.oevbs.kunde.kundenportal2.model.services.contact.types.ContactMessageType
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.Handler
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class ContactMessageStore(job: Job) : ValidatingStore<ContactMessage, Unit, ComponentValidationMessage>(
    initialData = ContactMessage(),
    ContactMessage.validation,
    metadataDefault = Unit,
    job,
    validateAfterUpdate = false
) {

    private val client = ContactClient()

    private val initFailedStore = storeOf(false, Job())
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    private val progressStore = storeOf(GeneralProgressStep.SUBMIT1, job)
    val progress: Flow<GeneralProgressStep> = progressStore.data

    val initData = storeOf(ContactMessageInit(), job)

    var lastMessageSent: String = ""
        private set

    val initModel: Handler<Unit> = initData.handle {
        GlobalServiceMessagesStore.clear(Unit)
        resetMessages()
        lastMessageSent = ""
        globalInitTracker.track {
            val initData = initContact()
            if (initData == null) {
                initFailedStore.update(true)
                return@track ContactMessageInit()
            }
            initData
        }
    }

    val submitMessage: Handler<Unit> = handle { message ->
        GlobalServiceMessagesStore.clear(Unit)

        if (!validate(message).valid)
            return@handle message

        val success = globalSubmitTracker.track {
            sendMessage(message)
        }

        if (success) {
            progressStore.update(GeneralProgressStep.SUCCESS2)
        }

        lastMessageSent = createContactNote(message.type)
        ContactMessage()
    }

    private fun createContactNote(messageType: String): String =
        current.run {
            when (messageType) {
                ContactMessageType.CONSULTANT_MESSAGE.text -> PortalContactNotes.AdvisorMessageSent(content)
                ContactMessageType.COMPLAINT_MESSAGE.text -> PortalContactNotes.ComplaintMessageSent(
                    complaintSubjects,
                    complaintReasons,
                    complaintSolution,
                    content,
                    contract?.id ?: "",
                    claim?.id ?: ""

                )

                ContactMessageType.CONTRACT_INFORMATION.text -> PortalContactNotes.ContractMessageSent(
                    contract?.id ?: "",
                    content
                )

                ContactMessageType.LOSS_INFORMATION.text -> PortalContactNotes.ClaimMessageSent(
                    claim?.id ?: "",
                    content
                )

                else -> PortalContactNotes.MessageSent(content)
            }.note
        }

    private suspend fun sendMessage(message: ContactMessage): Boolean {
        tryCatchAndHandleErrors("Senden einer ContactMessage") {
            client.send(message)
        } ?: return false

        return true
    }

    private suspend fun initContact(): ContactMessageInit? {
        return tryCatchAndHandleErrors("Initialisieren des Kontakt-Bereiches") {
            client.init()
        }
    }
}